import axios from "axios";
import resultSettlementHours from "../../models/gestionTiempos/information/resultSettlementHours";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getResultsSettlement(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const empId = localStorage.getItem("empId");
    return axios
      .get(`${url}/liqd/${empId}&${data}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return resultSettlementHours.fromJson(item);
        })
      );
  }
  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const empId = localStorage.getItem("empId");
    const fecha = data.date;
    const conceptoid = data.conceptId;
    const cscostoid = data.csCostoId;
    let payload = {
      cantAut: data.authorizedAmount,
      cantNoAut: data.unauthorizedAmount,
    };
    return axios
      .patch(
        `${url}/liqd/${empId}&${fecha}&${conceptoid}&${cscostoid}`,
        payload,
        { headers }
      )
      .then(() => {});
  }
}
export default service;
